(function(appComponents) {

	var reviewCollection = function (parent) {
		var collection = {};
		collection._product = parent._product;

		var reviewItemPrototype = {
			downloadDataPack : function (type) {
				collection._product.downloadDataPack(this.product.stockId, type);
			}
		};

		collection.setCollection = function (items) {

			this.collection = items;
			$.each(this.collection, function(index, el){
				this._parentElement = $("[pc-container='order-checkout--review-item'][pc-value='" + el.pk + "']");
				this.__proto__ = reviewItemPrototype;
			});
		};

		collection.findItemByPk = function(pk) {
			var entryToReturn = null;
			this.collection.forEach(function(el){
				if (el.pk == pk) {
					entryToReturn = el;
				}
			});
			return entryToReturn;
		};

		return collection;
	};
	
	if (appComponents.pageComponents == null) appComponents.pageComponents = {};
	if (appComponents.pageComponents.orderCheckout == null) appComponents.pageComponents.orderCheckout = {};
	appComponents.pageComponents.orderCheckout.reviewCollection = reviewCollection;

	window.appComponents = appComponents;

})(window.appComponents || {});	